var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    `notification`,
    _vm.type === `success` && `notification--success`,
    _vm.type === `error` && `notification--error`,
    _vm.type === `warning` && `notification--warning`,
    _vm.type === `info` && `notification--info`,
  ]},[_c('span',{on:{"click":_vm.handleIconClick}},[(_vm.icon)?_c('icon',{attrs:{"class-name":"notification__icon","name":_vm.icon},on:{"click":_vm.handleIconClick}}):_vm._e()],1),(_vm.title)?_c('div',{staticClass:"notification__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"notification__text"},[_vm._t("default")],2),(_vm.actions)?_c('div',{staticClass:"notification__actions"},[_vm._t("action-content",function(){return [_c('a',{staticClass:"notification__actions__action"},[_vm._v("Default Modal Content from Slots (Fallback)")])]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }